<template>
  <div id="nf-content-top">
    <!-- 顶部搜索组件 -->
    <nf-top-select
      v-if="haveSearch"
      :is-top-row="isTopRow"
      :top-left-text="topLeftText"
      :warn-tip-text="warnTipText"
      :top-title-show="topTitleShow"
      :is-more-search-btn="isMoreSearchBtn"
      :store-model-name="storeModelName"
    >
      <!-- 顶部自定义button -->
      <div slot="top-title-right">
        <slot name="top-title-right" class="top-title-right" />
      </div>
      <!-- 统计数据 -->
      <div slot="top-title-show" class="show-content">
        <slot name="top-title-show" />
      </div>
    </nf-top-select>
    <!-- 其他模块 -->
    <div slot="other-module">
      <slot name="other-module" />
    </div>
    <nf-table
      v-if="!customTable"
      :import-url="importUrl"
      :is-export-btn="isExportBtn"
      :is-search-bar="isSearchBar"
      :on-table-select="onTableSelect"
      :handle-to-add-click="handleToAddClick"
      :is-table-select="isTableSelect"
      :right-buttons="rightButtons"
      :export-url="exportUrl"
      :store-model-name="storeModelName"
      :add-btn-link="addBtnLink"
      :is-edit-table-btn="isEditTableBtn"
      :is-get-list="isGetList"
      :current-page-size="currentPageSize"
      :show-summary="showSummary"
      :tree-load-fn="treeLoadFn"
      :row-h="rowH"
      :hrow-h="hrowH"
      :is-pagination="isPagination"
      :is-operation-fixed="isOperationFixed"
      :add-btn-link-text="addBtnLinkText"
      :el-table-height="elTableHeight"
      :render-header="renderHeader"
      :on-handle-search-btn-click="onHandleSearchBtnClick"
      :on-handle-reset-btn-click="onHandleResetBtnClick"
      :single-page="singlePage"
      :selectable="selectable"
      :padding="padding"
    >
      <!-- 左侧查询 -->
      <div slot="top-btn-left">
        <slot name="top-btn-left" />
      </div>
      <!-- 右侧button -->
      <div slot="top-btn-right">
        <slot name="top-btn-right" />
      </div>

      <div slot="table-foot">
        <slot name="table-foot" />
      </div>

      <!-- 根据tableHeadList slotNameHeader字端 动态插入 插槽 自定义表头 -->
      <template v-for="item of tableHeadListSlotNameHeader" :slot="item.slotNameHeader">
        <slot :name="item.slotNameHeader" />
      </template>
      <div slot="statistics">
        <slot name="statistics" />
      </div>
      <!-- 根据tableHeadList slotName字端 动态插入 插槽 -->
      <template v-for="item in tableHeadListSlotName" :slot="item.slotName" slot-scope="scope">
        <div :key="item.slotName">
          <slot :name="item.slotName" :scope="scope.scope" />
        </div>
      </template>
    </nf-table>
  </div>
</template>
<script>
export default {
  name: 'NfList',
  props: {
    // 是否有自定义table
    customTable: {
      type: Boolean,
      default: false,
    },
    // 是否显示分页
    isPagination: {
      type: Boolean,
      default: true,
    },
    // 是否显示搜索栏
    haveSearch: {
      type: Boolean,
      default: true,
    },
    // 是否显示 搜索栏 顶部title 内一栏
    isTopRow: {
      type: Boolean,
      default: true,
    },
    // 导入excel地址
    importUrl: {
      type: String,
      default: '',
    },
    exportUrl: {
      type: String,
      default: '',
    },
    // 导出excel按钮是否显示
    isExportBtn: {
      type: Boolean,
      default: false,
    },
    // 多选回调方法
    onTableSelect: {
      type: Function,
      default: () => {},
    },
    // table左上的按钮
    handleToAddClick: {
      type: Function,
      default: () => {},
    },
    // 是否显示表格的多选按钮
    isTableSelect: {
      type: Boolean,
      default: false,
    },
    // 添加按钮路由路径
    addBtnLink: {
      type: String,
      default: '',
    },
    // vuex Model 名称
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    // 是否显示table操作栏
    rightButtons: {
      type: Array,
      default: () => [],
    },
    // 是否显示重置按钮
    isResetBtn: {
      type: Boolean,
      default: false,
    },
    // 查询和重置框
    isSearchBar: {
      type: Boolean,
      default: false,
    },
    // 是否显示高级搜索按钮
    isMoreSearchBtn: {
      type: Boolean,
      default: false,
    },
    // 是否显示合计
    showSummary: {
      type: Boolean,
      default: false,
    },
    // 是否开启编辑表头功能
    isEditTableBtn: {
      type: Boolean,
      default: true,
    },
    // nf-table creatd 函数 是否请求列表数据
    isGetList: {
      type: Boolean,
      default: true,
    },
    // 组件布局，子组件名用逗号分隔
    paginationLayout: {
      type: String,
      default: 'total,sizes, prev, pager, next',
    },
    // 点击分页监听变化
    onHandleCurrentChange: {
      type: [Function, Boolean],
      default: false,
    },
    // 点击查询按钮
    onHandleSearchBtnClick: {
      type: [Function, Boolean],
      default: false,
    },
    // 表格 当某一行被点击时会触发该事件
    onTableRowClick: {
      type: [Function, Boolean],
      default: false,
    },
    // 点击重置按钮触发
    onHandleResetBtnClick: {
      type: [Function, Boolean],
      default: false,
    },
    // 操作按钮是否固定在右侧浮动
    isOperationFixed: {
      type: Boolean,
      default: false,
    },
    // table的高度
    elTableHeight: {
      type: [Number, String],
      default: 0,
    },
    // 搜索左上角文字
    topLeftText: {
      type: String,
      default: '',
    },
    warnTipText: {
      type: String,
      default: '',
    },
    topTitleShow: {
      type: Boolean,
      default: false,
    },
    // 添加按钮文字
    addBtnLinkText: {
      type: String,
      default: '添加',
    },
    treeLoadFn: {
      type: [Function, Boolean],
      default: false,
    },
    // 自定义header
    renderHeader: {
      type: [Function, Boolean],
      default: false,
    },
    // 表格行高
    rowH: {
      type: String,
      default: '60px',
    },
    //  表头行高
    hrowH: {
      type: String,
      default: '40px',
    },
    currentPageSize: {
      type: Number,
      default: 20,
    },
    singlePage: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    selectable: Function,
  },
  computed: {
    // 从store里读取列表数据
    tableHeadList() {
      return this.$store.state[this.storeModelName].listData.tableHeadList;
    },
    // 找出带插槽的自定义表头
    tableHeadListSlotNameHeader() {
      return (this.tableHeadList && this.tableHeadList.filter(item => item.slotNameHeader)) || [];
    },
    // 找出带插槽的数据Item
    tableHeadListSlotName() {
      return (this.tableHeadList && this.tableHeadList.filter(item => item.slotName)) || [];
    },
  },
};
</script>
